import { Card, Image, Text, Stack, Group, Box } from "@mantine/core";
import { Citation, Response as ResponseData } from "../types";

interface CitationCardProps {
    citation: Citation;
    onClick: (citation: Citation) => void;
}

export const CitationCard = ({ citation, onClick }: CitationCardProps) => {
    const getThumbnailUrl = (citation: Citation): string => {
        if (citation.thumbnailUrl) {
            return citation.thumbnailUrl;
        }

        if (citation.source.source === "intellum") {
            return citation.source.intellumOrganization == "AGU" ? "/static/agu.webp" : "/static/orthopedia.webp";
        }

        return "/static/document.webp";
    };

    const getCitationType = (citation: Citation): string => {
        if (citation.source.source == "intellum") {
            return citation.source.intellumOrganization == "AGU" ? "Arthrex Global University" : "Orthopedia ";
        }

        if (citation.source.publicationId) {
            return "Study";
        }

        if (citation.source.source == "playbook") {
            return "Playbook";
        }

        return citation.tooltip.category;
    };

    return (
        <Card
            shadow="sm"
            padding="lg"
            radius="md"
            withBorder
            w="100%"
            h="100%" // makes the card stretch to match grid height
            style={{
                display: "flex",
                flexDirection: "column"
            }}
        >
            <Card.Section style={{ cursor: "pointer" }} onClick={() => onClick(citation)}>
                <Image src={getThumbnailUrl(citation)} height={160} alt={citation.title} />
            </Card.Section>

            {/* This Box must grow to fill all available vertical space */}
            <Box
                style={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    justifyContent: "space-between" // distributes content and pushes bottom row
                }}
            >
                <Stack style={{ cursor: "pointer" }} mt="sm" gap={4} onClick={() => onClick(citation)}>
                    <Text fw={500}>
                        [{citation.footnoteNumber}] {citation.title}
                    </Text>
                    <Text c="gray.6" size="sm">
                        {citation.lastModifiedTimestamp != null ? new Date(Date.parse(citation.lastModifiedTimestamp)).toLocaleDateString() : ""}
                    </Text>
                    <Text c="gray.6" size="sm">
                        {getCitationType(citation)}
                    </Text>
                </Stack>
            </Box>
        </Card>
    );
};
